<span *ngIf="size === iconSize.regular">
  <svg height="40"
       width="40">
    <rect x="0" y="0"
          width="40" height="40" stroke="gray"
          [attr.stroke-width]="strokeWidth.toString()"
          [attr.fill]="'#' + colorHex"></rect>
    <text x="20" y="22" dominant-baseline="middle" text-anchor="middle"
          style="font-weight: bold;font-size: 20px;" [ngStyle]="{'fill': textColor}">
      {{ iconInitials }}
    </text>
  </svg>
</span>

<span *ngIf="size === iconSize.small">
  <svg height="32"
       width="32">
    <rect x="0" y="0"
          width="32" height="32" stroke="gray"
          [attr.stroke-width]="strokeWidth.toString()"
          [attr.fill]="'#' + colorHex"></rect>
    <text x="16" y="17" dominant-baseline="middle" text-anchor="middle"
          style="font-weight: bold;font-size: 16px;" [ngStyle]="{'fill': textColor}">
      {{ iconInitials }}
    </text>
  </svg>
</span>

<span *ngIf="size === iconSize.extraSmall">
  <svg height="24"
       width="24">
    <rect x="0" y="0"
          width="24" height="24" stroke="gray"
          [attr.stroke-width]="strokeWidth.toString()"
          [attr.fill]="'#' + colorHex"></rect>
    <text x="12" y="13" dominant-baseline="middle" text-anchor="middle"
          style="font-weight: bold;font-size: 12px;" [ngStyle]="{'fill': textColor}">
      {{ iconInitials }}
    </text>
  </svg>
</span>
